import { menuAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";

import { BOX_SHADOW_VARIANT } from "components/constants/style/boxShadow";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(menuAnatomy.keys);

const baseStyleList = defineStyle({
  bg: "bg.container",
  py: "0",
  borderWidth: "1px",
  borderColor: "border.container",
  borderStyle: "solid",
  boxShadow: BOX_SHADOW_VARIANT.sm,
  transitionDuration: (theme) => theme.transition.duration.fast,
  borderRadius: "lg",
  overflowY: "auto",
  mb: "2",
});

const baseStyleItem = defineStyle({
  textStyle: "base",
  p: "2",
  bg: "bg.container",
  color: "fg.emphasized",
  _focus: {
    bg: "highlight.default",
  },
  _active: {
    bg: "highlight.default",
  },
  _disabled: {
    cursor: "default",
    opacity: 1,
    color: "fg.muted",
    svg: { fill: "fg.muted" },
  },
});

const baseStyleButton = defineStyle({
  padding: "2",
  textStyle: "base",
});

const baseStyleGroupTitle = defineStyle({
  color: "fg.emphasized",
  mx: "2",
  mt: "0",
  mb: "1",
  textStyle: "baseBold",
});

const baseStyle = definePartsStyle({
  button: baseStyleButton,
  list: baseStyleList,
  item: baseStyleItem,
  groupTitle: baseStyleGroupTitle,
});

export const Menu = defineMultiStyleConfig({
  baseStyle,
});
